"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HorizontalSeriesResult = void 0;
class HorizontalSeriesResult {}
exports.HorizontalSeriesResult = HorizontalSeriesResult;